import { useDispatch } from "react-redux";

import { useQuery } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { ApiQueryParams, ApiResponse } from "types/api";

import { transformDraftToVariant } from "./transformers";
import { TiVoAppProvider } from "./types";

export const useProvider = (id?: string, queryParams?: ApiQueryParams) => {
  const dispatch = useDispatch();

  return useQuery<ApiResponse<TiVoAppProvider>>({
    queryKey: ["provider", id, queryParams],
    queryFn: async () =>
      dispatch(
        apiThatThrows.getTiVoProvider.action({
          params: { id },
          queryParams,
        })
      ),
    select: (data) => {
      const transformedDraft =
        data.results.variants && data.results.variantDraft
          ? transformDraftToVariant(data.results.variantDraft)
          : undefined;
      const variants = data.results.variants || [];
      return {
        meta: data.meta,
        results: {
          ...data.results,
          variants: transformedDraft
            ? [transformedDraft, ...variants]
            : variants,
        },
      };
    },
    enabled: Boolean(id),
  });
};
